import { defineComponent, ref, computed } from "vue";
import Paragraph from "./component-library5.mjs";
import GdprPermissionLayer from "./component-library255.mjs";
import PlayPauseButton from "./component-library12.mjs";
import { registerConsent, isSocialConsentGiven } from "./component-library83.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "youtube-video",
  props: {
    videoId: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    },
    duration: {
      type: String,
      default: ""
    },
    uploadDate: {
      type: String,
      default: ""
    },
    border: {
      type: Boolean
    },
    overlayOpacity: { type: Number, default: 1 }
  },
  emits: ["open"],
  setup(__props, { expose, emit: emits }) {
    const props = __props;
    const youtubeDisclaimer = ref("* Videoinhalte werden von Youtube abgerufen");
    const isOpened = ref(false);
    const url = computed(() => `https://www.youtube-nocookie.com/embed/${props.videoId}`);
    const autoplayUrl = computed(() => `${url.value}?autoplay=1&rel=0`);
    const imgSrc = computed(() => `https://i.ytimg.com/vi_webp/${props.videoId}/hqdefault.webp`);
    const imgSrcSm = computed(() => `https://i.ytimg.com/vi_webp/${props.videoId}/sddefault.webp`);
    const imgSrcMd = computed(() => `https://i.ytimg.com/vi_webp/${props.videoId}/maxresdefault.webp`);
    const srcset = computed(() => {
      return `
        ${imgSrc.value} 480w,
        ${imgSrcSm.value} 640w,
        ${imgSrcMd.value} 1280w
      `.trim();
    });
    const embedUrl = computed(() => `https://youtube.googleapis.com/v/${props.videoId}`);
    const minutes = computed(() => {
      if (!props.duration) {
        return void 0;
      }
      return parseInt(props.duration.split(":")[0], 10);
    });
    const seconds = computed(() => {
      if (!props.duration) {
        return void 0;
      }
      return parseInt(props.duration.split(":")[1], 10);
    });
    const iso8601duration = computed(() => {
      if (!minutes.value || !seconds.value) {
        return void 0;
      }
      return `PT${minutes.value}M${seconds.value}S`;
    });
    const totalSeconds = computed(() => {
      if (!minutes.value || !seconds.value) {
        return void 0;
      }
      return minutes.value * 60 + seconds.value;
    });
    const hasItemprops = computed(() => props.description);
    const jsonUploadDate = computed(() => {
      if (!props.uploadDate) {
        return void 0;
      }
      const [day, month, year] = props.uploadDate.split(".").map((s) => parseInt(s, 10));
      const date = new Date(year, month - 1, day + 1);
      return date.toJSON();
    });
    const classes = computed(() => {
      const modifier = [];
      if (props.border)
        modifier.push("youtube-video--bordered");
      return modifier;
    });
    registerConsent();
    const open = () => {
      isOpened.value = true;
      emits("open");
    };
    expose({
      open,
      autoplayUrl,
      url,
      imgSrc,
      imgSrcSm,
      jsonUploadDate,
      imgSrcMd,
      embedUrl,
      minutes,
      seconds,
      totalSeconds,
      iso8601duration
    });
    return { __sfc: true, props, emits, youtubeDisclaimer, isOpened, url, autoplayUrl, imgSrc, imgSrcSm, imgSrcMd, srcset, embedUrl, minutes, seconds, iso8601duration, totalSeconds, hasItemprops, jsonUploadDate, classes, open, Paragraph, GdprPermissionLayer, PlayPauseButton, isSocialConsentGiven };
  }
});
export {
  _sfc_main as default
};
